import { t } from 'i18next';
import { Modal, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';

export type AddFileOptionType = 'camera' | 'gallery' | 'website';

type AddFileOptionsModalProps = {
  visible: boolean;
  onClose: () => void;
  onSelectType: (type: AddFileOptionType) => void;
};

export const AddFileOptionsModal = ({
  visible,
  onClose,
  onSelectType,
}: AddFileOptionsModalProps) => (
  <Modal
    visible={visible}
    transparent
    animationType="slide"
    onRequestClose={onClose}
  >
    <TouchableOpacity
      style={styles.modalBackdrop}
      activeOpacity={1}
      onPress={onClose}
    >
      <View style={styles.bottomSheetContainer}>
        <Button
          size="large"
          variant="rectangular"
          onPress={() => onSelectType('camera')}
        >
          {t('asset.files.camera')}
        </Button>
        <Button
          size="large"
          variant="rectangular"
          onPress={() => onSelectType('gallery')}
        >
          {t('asset.files.gallery')}
        </Button>
        <Button
          size="large"
          variant="rectangular"
          onPress={() => onSelectType('website')}
        >
          {t('asset.files.website')}
        </Button>
      </View>
    </TouchableOpacity>
  </Modal>
);

const styles = StyleSheet.create({
  modalBackdrop: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  bottomSheetContainer: {
    backgroundColor: Colors.white,
    paddingVertical: 34,
    paddingHorizontal: 16,
    gap: 16,
    marginBottom: 90,
  },
});
